import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { BRAND, ASSETS, NAV } from "@/lib/brand";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-pe-ink text-pe-cream/90">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5 space-y-6">
            <img src={ASSETS.logo_light} alt="Pizza Excellente" className="h-16 md:h-20 w-auto object-contain" />
            <p className="font-serif text-2xl leading-[1.25] text-pe-cream max-w-md">
              A neighborhood-first pizza brand bringing authentic thin-crust pizza and gluten-free options to India’s residential communities.
            </p>
            <a
              data-testid="footer-email-link"
              href={BRAND.mailto}
              className="inline-flex items-center gap-2 text-pe-orange hover:text-white transition-colors text-sm tracking-wide"
            >
              <Mail size={16} /> {BRAND.email}
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="eyebrow text-pe-orange mb-5">Explore</h4>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <Link
                    to={n.href}
                    data-testid={`footer-link-${n.href.replace(/\W+/g, "-").replace(/^-|-$/g, "") || "home"}`}
                    className="text-pe-cream/75 hover:text-pe-cream text-sm transition-colors"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="eyebrow text-pe-orange mb-5">Get in touch</h4>
            <p className="text-pe-cream/75 text-sm leading-relaxed mb-4">
              For franchise, investor, landlord, supplier or media enquiries, our team reads every message.
            </p>
            <a
              data-testid="footer-cta-contact"
              href={BRAND.mailto}
              className="inline-flex items-center justify-center bg-pe-orange text-pe-ink text-[12px] font-medium tracking-[0.15em] uppercase px-6 py-3 hover:bg-white transition-colors"
            >
              Contact Pizza Excellente
            </a>
            <div className="mt-8 text-pe-cream/60 text-sm flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 shrink-0" />
              <span>Launching soon in Greater Noida, Uttar Pradesh — expanding across Tier 2 & 3 India.</span>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-pe-cream/50">
          <p>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
          <p className="font-serif italic text-pe-orange/80">{BRAND.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
